import { LinkType } from 'fym-common/src/utils/recognizeLinkTypeByUrl';
import { MusicService } from 'fym-shared/src/music-services/types';
import { amazonMusic } from 'fym-shared/src/music-services/services/AmazonMusic';
import { appleMusic } from 'fym-shared/src/music-services/services/AppleMusic';
import { deezer } from 'fym-shared/src/music-services/services/Deezer';
import { pandora } from 'fym-shared/src/music-services/services/Pandora';
import { soundcloud } from 'fym-shared/src/music-services/services/SoundCloud';
import { spotify } from 'fym-shared/src/music-services/services/Spotify';
import { tidal } from 'fym-shared/src/music-services/services/Tidal';
import { youtube } from 'fym-shared/src/music-services/services/YouTube';
import { youtubeMusic } from 'fym-shared/src/music-services/services/YouTubeMusic';
import { napster } from 'fym-shared/src/music-services/services/Napster';
import { qobuz } from 'fym-shared/src/music-services/services/Qobuz';
import { qqMusic } from 'fym-shared/src/music-services/services/QQMusic';
import { yandexMusic } from 'fym-shared/src/music-services/services/YandexMusic';
import { vkMusic } from 'fym-shared/src/music-services/services/VKMusic';
import { zvuk } from 'fym-shared/src/music-services/services/Zvuk';
import { gaana } from 'fym-shared/src/music-services/services/Gaana';
import { jiosaavn } from 'fym-shared/src/music-services/services/JioSaavn';
import { resso } from 'fym-shared/src/music-services/services/Resso';
import { boomplay } from 'fym-shared/src/music-services/services/Boomplay';

export function musicServiceForLink(type: LinkType): MusicService | null {
  switch (type) {
    case LinkType.amazonmusic:
      return amazonMusic;
    case LinkType.applemusic:
      return appleMusic;
    case LinkType.deezer:
      return deezer;
    case LinkType.pandora:
      return pandora;
    case LinkType.soundcloud:
      return soundcloud;
    case LinkType.spotify:
      return spotify;
    case LinkType.tidal:
      return tidal;
    case LinkType.youtube:
      return youtube;
    case LinkType.youtubemusic:
      return youtubeMusic;
    case LinkType.napster:
      return napster;
    case LinkType.qobuz:
      return qobuz;
    case LinkType.qqmusic:
      return qqMusic;
    case LinkType.yandexmusic:
      return yandexMusic;
    case LinkType.vkmusic:
      return vkMusic;
    case LinkType.zvuk:
      return zvuk;
    case LinkType.gaana:
      return gaana;
    case LinkType.jiosaavn:
      return jiosaavn;
    case LinkType.resso:
      return resso;
    case LinkType.boomplay:
      return boomplay;
    case LinkType.generic:
    case LinkType.anghami:
    case LinkType.audiomack:
    case LinkType.audius:
    case LinkType.facebook:
    case LinkType.instagram:
    case LinkType.twitter:
    case LinkType.linkedin:
    case LinkType.tiktok:
    case LinkType.reddit:
    case LinkType.snapchat:
    default:
      return null;
  }
}
